import Skeleton from 'react-loading-skeleton';
import React from 'react';

interface IProps {
  text?: string | number;
  skeletonWidth: number;
}
const OrderLogText = ({ text, skeletonWidth }: IProps) => {
  if (text) {
    return text;
  }
  if (!text?.toString()?.length) return '-';
  return <Skeleton width={skeletonWidth} />;
};

export default OrderLogText;
